import { styled, StyletronComponent } from 'styletron-react';

export const dndWrapperStyles = (isDragging: any) => {
    return {
        backgroundColor: isDragging ? 'var(--epods--color-blue-50)' : 'white',
        border: isDragging && '1px dashed var(--epods--color-blue-a-700)',
        borderRadius: 'var(--epods--border-radius)',
        boxShadow: 'var(--epods--box-shadow-third-bottom)',
        overflow: 'auto',
        display: 'flex',
        padding: '9px 9px 6px 9px',
    };
};

export const StyledDraggingItem: StyletronComponent<any> = styled('div', {
    border: '1px solid var(--epods--color-border)',
    backgroundColor: 'var(--epods--color-white)',
    borderRadius: 'var(--epods--border-radius)',
    display: 'flex',
    alignItems: 'center',
    padding: '0 9px 0 9px',
    height: '38px',
    width: '50px',
});

export const styledDraggingItemStyles = () => {
    return {
        border: '1px solid var(--epods--color-border)',
        backgroundColor: 'var(--epods--color-white)',
        borderRadius: 'var(--epods--border-radius)',
        display: 'flex',
        alignItems: 'center',
        padding: '0 9px 0 9px',
        height: '38px',
        width: '50px',
    };
};